import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'fidelityComments',
    label: 'Comments',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
